import classNames from 'classnames';
import React from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet';
import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';
import Dropdown from 'components/Dropdown';
import OutletModal from 'components/Fields/ReduxForm/OutletModal';
import MenuTitle from 'components/MenuTitle';
import { isFullSiteMode, isMobileDevice } from 'utils/fullSite';
import withFeatureFlags from 'hocs/withFeatureFlags';
import Joyride, { EVENTS, STATUS, ACTIONS } from 'react-joyride';
import Tooltip from 'components/TooltipComponent';
import { setUserProperty } from 'actions/userProperties';
import * as clevertapReportsSummary from 'clevertap/reports/summary';
import styles from './ActionBar.css';

const FTUE_STEPS_EXPORT = [
  {
    id: 1,
    title: 'Improvement around the corner!',
    content:
      'One click for <i> each outlet’s </i> report combined into one. Available on Sales Summary, Gross Profit, and Payment Methods.',
    target: '#export-button',
    disableBeacon: true,
    buttonText: 'Download',
    placement: 'bottom',
    spotlightClicks: true,
    floaterProps: {
      options: {
        preventOverflow: {
          padding: 35,
        },
      },
    },
  },
];

const FTUE_STEPS_NEW_EXPORT = [
  {
    id: 1,
    title: 'Improvement around the corner!',
    content:
      'Now you can <i>export</i> the report with the detail of each outlet. Less hassle to grow your business bigger, faster!',
    target: '#export-drop-down',
    disableBeacon: true,
    buttonText: 'Let’s Try it Out!',
    placement: 'bottom',
    spotlightClicks: true,
    floaterProps: {
      options: {
        preventOverflow: {
          padding: 35,
        },
      },
    },
  },
  {
    id: 2,
    title: "Get outlets' numbers, hassle free!",
    content:
      'One click for <i> each outlet’s </i> report combined into one. Available on Sales Summary, Gross Profit, and Payment Methods.',
    target: '#export-per-outlet',
    disableBeacon: true,
    buttonText: 'Download',
    placement: 'bottom',
    spotlightClicks: true,
    floaterProps: {
      options: {
        preventOverflow: {
          padding: 35,
        },
      },
    },
  },
];

class ActionBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      run: true,
      stepIndex: 0,
      openDropDown: false,
      isFirstTime:
        props.userPropertiesLoaded &&
        !props.ftueSalesSummaryOutletComparisonShown,
    };
    this._tooltipWithDots = Tooltip({
      onClickStep: this._handleClickJoyRideStep,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.userPropertiesLoaded && !prevProps.userPropertiesLoaded) {
      this.setState({
        isFirstTime: !this.props.ftueSalesSummaryOutletComparisonShown,
      });
    }
  }

  render() {
    const {
      outlets,
      exportMenus,
      onChangeDate,
      onChangeOutlet,
      showModalOutletMobileState,
      showExportFtue,
      outletComparisonEnabled,
      outletComparisonFtueEnabled,
    } = this.props;
    const showFtue =
      outletComparisonEnabled &&
      outletComparisonFtueEnabled &&
      showExportFtue &&
      !isMobileDevice() &&
      this.state.isFirstTime;

    return (
      <div className="action-bar-wrapper">
        {showFtue && (
          <Joyride
            continuous
            run={this.state.run}
            steps={
              exportMenus.length > 0 ? FTUE_STEPS_NEW_EXPORT : FTUE_STEPS_EXPORT
            }
            callback={this._handleJoyCallback}
            tooltipComponent={this._tooltipWithDots}
            spotlightPadding={1}
            disableCloseOnEsc
            disableOverlayClose
            stepIndex={this.state.stepIndex}
            floaterProps={{
              disableAnimation: true,
            }}
            styles={{
              options: {
                arrowColor: '#333232',
                zIndex: 2000,
              },
            }}
          />
        )}
        <MenuTitle menuTitle="Sales" />
        {this._renderExportButton()}
        <div className="mk-action-bar">
          <div className="row">
            <div className="col-sm-12 col-md-9">
              <div className="visible-md visible-lg pull-left mr-5px">
                <Field
                  component={DropdownOutlet}
                  outlets={outlets}
                  onChangeOutletIds={onChangeOutlet}
                  name="outlet"
                  allOutletOption
                />
              </div>
              <div className="pull-left">
                <Field
                  component={DropdownCalendar}
                  name="date"
                  onChange={onChangeDate}
                  updateServerOnChange
                />
              </div>
            </div>
            <Field
              component={OutletModal}
              name="outlet"
              outlets={outlets}
              onChangeOutletIds={onChangeOutlet}
              allOutletOption
              show={showModalOutletMobileState}
            />
          </div>
        </div>
      </div>
    );
  }

  _renderExportButton() {
    if (isFullSiteMode()) {
      return;
    }

    const { exportMenus } = this.props;
    const actionButtonGroupStyle = classNames([
      'export-button-group',
      'col-md-6',
      'visible-md',
      'visible-lg',
      'no-padding',
      'text-right',
      [styles['button-group']],
    ]);

    // The export button can be a plain button or a dropdown
    let exportButton;
    if (exportMenus.length > 0) {
      // Build menu items with divider
      const menuItems = exportMenus.reduce((memo, menu) => {
        memo.push(
          <MenuItem
            onSelect={this._onClickExportButton}
            eventKey={menu.key}
            key={menu.key}
            id={menu.id}
          >
            {menu.display}
          </MenuItem>
        );
        memo.push(<MenuItem divider key={`${menu.key}-divider`} />);

        return memo;
      }, []);

      // Remove last divider
      menuItems.pop();

      exportButton = (
        <Dropdown
          id="export-drop-down"
          pullRight
          open={this.state.openDropDown}
          onClick={this._handleToggleDropDown}
        >
          <Dropdown.Toggle title="Export" bsStyle="primary"></Dropdown.Toggle>
          <Dropdown.Menu>{menuItems}</Dropdown.Menu>
        </Dropdown>
      );
    } else {
      exportButton = (
        <a
          id="export-button"
          className="btn btn-primary export-button"
          onClick={this._onClickExportButton}
        >
          Export
        </a>
      );
    }

    return <div className={actionButtonGroupStyle}>{exportButton}</div>;
  }

  _onClickExportButton = reportType => {
    this.props.onExport(reportType);

    if (this.state.run) {
      const allOutlets = this.props.search.outlet.length > 1;
      clevertapReportsSummary.reportPerOutletFtue({
        filter: allOutlets ? 'All Outlet' : 'Single Outlet',
        step: allOutlets ? 2 : 3,
      });
    }

    this.setState({
      run: false,
      openDropDown: false,
    });
  };

  _handleJoyCallback = callBackProps => {
    const { index, status, type, action } = callBackProps;
    let step = index + 1;

    if (
      action === ACTIONS.START &&
      !this.props.ftueSalesSummaryOutletComparisonShown
    ) {
      this.props.dispatch(
        setUserProperty('ftueSalesSummaryOutletComparisonShown', true)
      );
    }

    if (index === 1 && action === ACTIONS.NEXT) {
      this.setState({ openDropDown: true });
    }

    // If Download button clicked
    if (action === ACTIONS.NEXT && status === STATUS.FINISHED) {
      step = 3;
      this._onClickExportButton('perOutlet');
    }

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart
      this.setState({
        openDropDown: false,
        run: false,
      });
    }

    if (type === EVENTS.TOUR_END && status !== STATUS.FINISHED) {
      clevertapReportsSummary.reportPerOutletFtue({
        filter:
          this.props.search.outlet.length > 1 ? 'All Outlet' : 'Single Outlet',
        step,
      });
    }
  };

  _handleToggleDropDown = () => {
    this.setState({
      openDropDown: !this.state.openDropDown,
      stepIndex: 1,
    });
  };

  _handleClickJoyRideStep = step => {
    this.setState({
      stepIndex: step,
      openDropDown: step !== 0,
    });
  };
}

const selector = formValueSelector('search');
const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  return {
    outlets: state.reports.sales.outlets,
    search: {
      outlet: selector(state, 'outlet'),
    },
    showModalOutletMobileState: state.moka.showModalOutletMobile,
    userPropertiesLoaded: state.userProperties.loaded,
    ftueSalesSummaryOutletComparisonShown:
      state.userProperties.props.ftueSalesSummaryOutletComparisonShown,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

ActionBar.propTypes = {
  onChangeOutlet: PropTypes.func,
  onChangeDate: PropTypes.func,
  onExport: PropTypes.func,
  showNewExportOption: PropTypes.bool,
  showExportFtue: PropTypes.bool,
  outletComparisonEnabled: PropTypes.bool,
  outletComparisonFtueEnabled: PropTypes.bool,
};

ActionBar.defaultProps = {
  outlets: [],
  exportMenus: [],
  showNewExportOption: false,
  showExportFtue: false,
  outletComparisonEnabled: false,
  outletComparisonFtueEnabled: false,
};

const mapFlagsToProps = flags => {
  return {
    outletComparisonEnabled: flags.summaryPerOutlet,
    outletComparisonFtueEnabled: flags.summaryPerOutletFtue,
  };
};

export default withFeatureFlags(mapFlagsToProps)(
  reduxForm(mapForm)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActionBar)
  )
);
